// @flow
import React from 'react'
import css from './MedicineTable.css'

type Props = {
  medicines: Array<Object>,
  maxPage: number,
  activePage: number,
  onActivePageChange: Function,

}

const getPaginationItems = (maxPage: number, activePage: number, onItemClick: Function) => {
  const items = []
  for(let i = 0; i < maxPage; i++) {
    items.push(i + 1)
  }
  return (
    items.map((item, index) => {
      return (<li key={`paginationItem_${index}`} className={(index === activePage) ? css.itemSelected : '' }><a onClick={() => onItemClick(item - 1)}>{item}</a></li>)
    })
  )
}

const MedicineTable = ({medicines, maxPage, activePage, onActivePageChange}: Props) => {
  const paginationItems = getPaginationItems(maxPage, activePage, onActivePageChange)

  return (
    <div className={css.component}>
      <table className={css.table}>
        <thead>
          <tr>
            <th style={{width: '20%'}}>Lääkeaine</th>
            <th style={{width: '20%'}}>Kauppanimi</th>
            <th style={{width: '10%'}}>Vahvuus</th>
            <th style={{width: '15%'}}>Lääkemuoto</th>
            <th style={{width: '10%'}}>ATC</th>
            <th style={{width: '10%'}}>VNR</th>
            <th style={{width: '15%'}}>Myyntilupa</th>
          </tr>
        </thead>
        <tbody>
          {medicines.map((medicine, index) =>
            <tr key={index}>
              <td>{medicine.activeIncr}</td>
              <td>{medicine.name}</td>
              <td>{medicine.intensity}</td>
              <td>{medicine.pharmForm}</td>
              <td>{medicine.atc}</td>
              <td>{medicine.vnr}</td>
              <td>{medicine.salesPermit}</td>
            </tr>
          )}
        </tbody>
      </table>
      <div className={css.pagination}>
        <ul>
          {paginationItems}
        </ul>
      </div>
    </div>
  )
}

export default MedicineTable



// WEBPACK FOOTER //
// ./src/admin/components/MedicineTable.js